module.exports = __webpack_public_path__ + "static/media/php.b187e3b1.png";